<template>
  <div>
    <h6>
      The customer balance is
      <span class="font-weight-medium">{{
        formatMoney({
          amount:
            (current.account.data.balance +
              AccountService.getUnbilledReadingCosts(current.coreId.data)
                .data) *
            -1,
        })
      }}</span
      >.
    </h6>
    <h6 class="font-weight-medium">
      This is less than
      {{ mustLeave2MonthCredit ? "2 x " : "" }}
      the set payment amount of
      {{
        formatMoney({
          amount: mustLeave2MonthCredit
            ? current.refundEligibility.data.setPaymentAmount / 2
            : current.refundEligibility.data.setPaymentAmount,
        })
      }}.
    </h6>
    <h6 class="mt-6 mb-8">
      As per our
      <SoLink
        text="refund policy"
        href="https://www.so.energy/refund-policy/"
      />, we suggest you keep your account in credit. We take payment in advance
      of each month, this means that it is correct for your account to be in
      credit of your payment amount. By issuing this refund the account will
      likely be in debit.
    </h6>

    <SoRadioGroup
      v-model="refundPolicyCheck"
      label="Does the customer accept the refund policy?"
      :items="[
        {
          text: 'Yes, the customer accepts they won’t have a refund today.',
          value: null,
        },
        { text: 'No, the customer still wants a refund.', value: true },
      ]"
      :rules="rules"
      hide-details
      @update:model-value="$emit('update:model-value', $event)"
    />
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { AccountService } from "@/services/AccountService"
  import { formatMoney } from "@/helpers/moneyHelpers"
  import { ValidationRule } from "@/types/ValidationRule"
  import SoRadioGroup from "@/components/formControls/SoRadioGroup.vue"
  import SoLink from "@/components/SoLink.vue"

  export default defineComponent({
    components: {
      SoRadioGroup,
      SoLink,
    },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
      },
      rules: {
        type: Array as PropType<ValidationRule[]>,
        default: [] as ValidationRule[],
        required: false,
      },
    },
    emits: ["update:model-value"],
    data() {
      return {
        current: useCurrentAccountStore(),
        AccountService,
        refundPolicyCheck: null,
        formatMoney,
      }
    },
    computed: {
      mustLeave2MonthCredit() {
        return this.current.refundEligibility.data.mustLeave2MonthCredit
      },
    },
  })
</script>
